"use client";

import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Stack,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import "./Service.css";
import AOS from "aos"

export default function Services() {
  AOS.init()
  return (
    <Stack  maxH={"100vh"} direction={{ base: "column", md: "row" }}>
      <Flex flex={1.5} align={"center"} justify={"center"}>
        <Stack data-aos="fade-up"
    data-aos-duration="3000" spacing={6} w={"100%"} maxW={"xl"}>
          <Heading>
            <Text
              as={"span"}
              position={"relative"}
              style={{
                color: "#F58538",
                fontFamily: "Oxygen",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: "700",
                lineHeight: "normal",
              }}
            >
              Service Offering
            </Text>
            <br />{" "}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Text
                style={{
                  color: "#001B14",
                  fontFamily: "Oxygen",
                  fontSize: "128px",
                  fontStyle: "normal",
                  fontWeight: "700",
                  lineHeight: "normal",
                }}
                as={"span"}
              >
                Why
              </Text>{" "}
              <Text
                style={{
                  borderRadius: "81.5px",
                  overflow: "hidden",
                  background: "#F58538",
                  zIndex: "100",
                  flexShrink: "0",
                }}
                as={"span"}
              >
                <img
                  style={{ zIndex: "-1", marginTop: "5px" }}
                  src={"/service-img1.png"}
                  alt={"img"}
                  width={"100%"}
                />
              </Text>
            </div>
            <br />
            <Text
              style={{
                color: "#001B14",
                fontFamily: "Oxygen",
                fontSize: "128px",
                fontStyle: "normal",
                fontWeight: "700",
                lineHeight: "normal",
              }}
              as={"span"}
            >
              Entelika
            </Text>{" "}
          </Heading>
        </Stack>
      </Flex>
      <Flex className="marquee" spacing={16} flex={1} px={"60px"}>
        <Stack  className="track pos" spacing={10}>
          <Box
            style={{
              width: "539px",
              height: "392px",
              borderRadius: "50px",
              background: "#F7F7F9",
              padding: "50px",
            }}
          >
            <Text>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="44"
                height="44"
                viewBox="0 0 44 44"
                fill="none"
              >
                <path
                  d="M7.20599 7.20605L37.206 37.2061"
                  stroke="#F58538"
                  stroke-width="5"
                />
                <path
                  d="M37.206 7.20605L7.20599 37.2061"
                  stroke="#F58538"
                  stroke-width="5"
                />
                <path
                  d="M21.6542 1L22.7579 43.412"
                  stroke="#F58538"
                  stroke-width="5"
                />
                <path
                  d="M43.412 21.6542L0.999999 22.7578"
                  stroke="#F58538"
                  stroke-width="5"
                />
              </svg>
            </Text>
            <Text className="serv-title1">Strategy and Service Design</Text>
            <Text paddingTop={4} className="serv-para1">
              Global pandemic has reiterated two philosophies of life - First,
              Change is the only constant (and can come absolutely unannounced).
              Second, only resilient organizations are capable to navigate
              sudden market transformations...
              <br />
              <div className="more-span1">Know More...</div>
            </Text>
          </Box>

          <Box
            style={{
              width: "539px",
              height: "610px",
              borderRadius: "50px",
              background: "#F4F0FE",
              textAlign: "left",
            }}
            padding={16}
          >
            <div>
              <img style={{ margin: "auto" }} src={"/service-img2.png"} />
            </div>
            <Text className="serv-title2">
              Transformation at <br /> Scale
            </Text>
            <Text paddingTop={4} className="serv-para1">
              It is a common saying - Ideas are worth pennies; it is the
              execution that only matters! We, at Entelika, absolutely believe
              in this hypothesis (though some of us at Entelika still believe -
              and are quite good - with generating ideas!)...
              <br />
              <div className="more-span1">Know More...</div>
            </Text>
          </Box>

          <Box
            style={{
              width: "539px",
              height: "610px",
              borderRadius: "50px",
              background: "#E7F4FE",
              textAlign: "left",
            }}
            padding={16}
          >
            <div >
              <img style={{ margin: "auto" }} src={"/service-img3.png"} />
            </div>
            <Text className="serv-title2">AI Based Software</Text>
            <Text paddingTop={4} className="serv-para1">
              At Entelika, we are continuously working towards providing a world
              class software to address the needs of our digitally connected
              customers. Our focus has always been on development and release of
              products in true agile framework with speed as well as accuracy...
              <br />
              <div className="more-span1">Know More...</div>
            </Text>
          </Box>
          <Box
            style={{
              width: "539px",
              height: "392px",
              borderRadius: "50px",
              background: "#001B14",
              padding: "50px",
              color: "white",
            }}
          >
            <Text style={{margin:"10px"}}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="44"
                height="44"
                viewBox="0 0 44 44"
                fill="none"
              >
                <path
                  d="M7.20599 7.20605L37.206 37.2061"
                  stroke="#F58538"
                  stroke-width="5"
                />
                <path
                  d="M37.206 7.20605L7.20599 37.2061"
                  stroke="#F58538"
                  stroke-width="5"
                />
                <path
                  d="M21.6542 1L22.7579 43.412"
                  stroke="#F58538"
                  stroke-width="5"
                />
                <path
                  d="M43.412 21.6542L0.999999 22.7578"
                  stroke="#F58538"
                  stroke-width="5"
                />
              </svg>
            </Text>
            <Text style={{ color: "white" }} className="serv-title1">
              Strategy and Service Design
            </Text>
            <Text
              style={{ color: "white" }}
              paddingTop={4}
              className="serv-para1"
            >
              Global pandemic has reiterated two philosophies of life - First,
              Change is the only constant (and can come absolutely unannounced).
              Second, only resilient organizations are capable to navigate
              sudden market transformations...
              <br />
              <div style={{ color: "white" }} className="more-span1">
                Know More...
              </div>
            </Text>
          </Box>
          <Box
            style={{
              width: "539px",
              height: "610px",
              borderRadius: "50px",
              background: "#FEF5E7",
              textAlign: "left",
            }}
            padding={14}
          >
            <div>
              <img style={{ margin: "auto" }} src={"/service-img4.png"} />
            </div>
            <Text style={{margin:"20px 0px"}} className="serv-title2">Operational Excellence</Text>
            <Text paddingTop={4} className="serv-para1">
              Entelika appreciates that a digital software product spends 80-85%
              of its lifetime in the operational part of the product life cycle
              while only 15-20% in the development cycle. As such, it is
              critical to focus on Site Reliability Engineering aspects during
              the development cycle....
              <br />
              <div className="more-span1">Know More...</div>
            </Text>
          </Box>
          <Box
            style={{
              width: "539px",
              height: "610px",
              borderRadius: "50px",
              background: "#F9ECEF",
              textAlign: "left",
              boxSizing:"borderBox"
            }}
            padding={16}
          >
            <div>
              <img style={{ margin: "auto" }} src={"/service-img5.png"} />
            </div>
            <Text style={{margin:"0px 30px"}} className="serv-title2">Customer Experience and Retention</Text>
            <Text paddingTop={4} className="serv-para1">
            Entelika understands that to survive and grow in today’s marketplace, our clients must pivot from selling products to delivering engaging customer services.
              <br />
              <div className="more-span1">Know More...</div>
            </Text>
          </Box>
        </Stack>
      </Flex>
    </Stack>
  );
}
